<template>
	<transition-height name="fade">
		<div class="champion-monthly" @click="share">
			<svg-badge-white v-if="isMobile" key="mobile" class="medal" />
			<svg-badge v-else key="non-mobile" class="medal" />

			<div>{{ t.mainChampionMonthlyCongrats }}</div>

			<button v-if="canGenericShare" type="button" name="button" class="btn-share-button">
				<font-awesome-icon icon="share-alt" />
				{{ t.genericShare }}
			</button>
			<button v-else type="button" name="button" class="btn-fb-share">
				<font-awesome-icon :icon="['fab', 'facebook-f']" />
				{{ t.mainChampionMonthlyShareButton }}
			</button>
		</div>
	</transition-height>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue';
import dayjs from '@/js/includes/dayjs';
import { insertText, stripTags } from '../../includes/helpers'
import SvgBadge from "@/svg/customer/images/components/champion-monthly/badge.svg"
import SvgBadgeWhite from "@/svg/customer/images/components/champion-monthly/badge-white.svg"
import { useStore } from '@/js/stores/index';
import { useUserStore } from '@/js/stores/user';

const store = useStore()
const userStore = useUserStore()

// Props
const props = defineProps({
	monthlyTopUrl: {
		type: [String, Boolean],
		required: false,
		default: '',
	}
})

// Emits
const emit = defineEmits(['loaded'])

// Reactives
const sharingInProgress = ref(false)

// Computeds
const t = computed(() => store.translations)
const isMobile = computed(() => store.isMobile)
const canGenericShare = computed(() => navigator.share)

// Methods
function shareOnFacebook(){
	if(typeof window.FB == 'undefined'){
		return
	}

	window.FB.ui({
		method: 'share',
		href: props.monthlyTopUrl,
	}, () => {
		sharingInProgress.value = false
	})
}

function share(){
	if(sharingInProgress.value){
		return
	}

	sharingInProgress.value = true

	if(!canGenericShare.value){
		return shareOnFacebook()
	}
	
	var monthName = t.value['championMonthlyLandingMonths' + (dayjs().subtract(1, "month").format("M"))]
	navigator.share({
		title: stripTags(insertText(t.value.championMonthlyLandingTitle, userStore.userFullName, monthName, dayjs().subtract(1, "month").format('YYYY'))),
		text: insertText(t.value.championMonthlyLandingIntroText, userStore.userFullName),
		url: props.monthlyTopUrl,
	}).catch(() => {
		// if (e.name !== 'AbortError') console.error(e);
	}).finally(() => {
		sharingInProgress.value = true
	})
}

// Lifecycle
onMounted(() => {
	emit('loaded')
})
</script>
